// Mock data for Just Cleaned Landing Page

export const heroData = {
  headline: "Communal Block Cleaning for Property Managers & Estate Agents",
  subheadline: "Reliable, scheduled cleaning for communal areas in managed blocks across North & Greater London.",
  ctaText: "Get a Free Site Assessment",
  microReassurance: "For managed blocks only • Fully insured • Fixed weekly rota • No missed cleans"
};

export const problemSolutionData = {
  problems: [
    "Resident complaints about dirty communal areas",
    "Inconsistent or missed cleans",
    "Chasing cleaners who don't show up",
    "Standards slipping over time"
  ],
  solution: "We provide dependable, scheduled communal block cleaning — done properly, every time.",
  solutionSubtext: "Designed for managing agents who need consistency, not constant follow-ups."
};

export const servicesData = {
  title: "What We Clean",
  services: [
    { icon: "Stairs", label: "Stairwells & landings" },
    { icon: "LayoutDashboard", label: "Communal corridors" },
    { icon: "DoorOpen", label: "Entrances & lobbies" },
    { icon: "ArrowUpDown", label: "Lifts" },
    { icon: "Trash2", label: "Bin areas" },
    { icon: "Sparkles", label: "Cobwebs & dust build-up" }
  ],
  clarification: "This is full communal area cleaning — not domestic or one-off cleans."
};

export const trustPointsData = {
  title: "Why Property Managers Choose Just Cleaned",
  points: [
    { icon: "Award", label: "4+ years of experience in communal block and managed building cleaning" },
    { icon: "Calendar", label: "Fixed schedules" },
    { icon: "CheckCircle", label: "Reliable attendance" },
    { icon: "MessageSquare", label: "Clear communication" },
    { icon: "User", label: "One point of contact" },
    { icon: "Shield", label: "Fully insured" },
    { icon: "MapPin", label: "Local service area" }
  ]
};

export const proofData = {
  title: "Examples of Communal Areas We Maintain",
  caption: "Examples of the standards we maintain for managed blocks.",
  captionSubtext: "These are maintained standards through regular cleaning — not one-off presentation cleans.",
  images: [
    {
      src: "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/zau03uwk_file_00000000171871f4a3c2df4d12d1a49f.png",
      alt: "Stairwell and landing cleaning - before and after"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/y2qzvnu6_file_00000000a4b071f4802b6c912b145b83%20%281%29.png",
      alt: "Communal corridor cleaning - before and after"
    }
  ]
};

export const audienceData = {
  forTitle: "This Is For",
  forList: [
    "Estate agents",
    "Property managers",
    "Managing agents",
    "Block managers"
  ],
  notForTitle: "This Is Not For",
  notForList: [
    "Domestic cleaning",
    "End-of-tenancy cleans",
    "Airbnb / short-let cleans",
    "One-off deep cleans"
  ]
};

export const processData = {
  title: "How It Works",
  steps: [
    {
      number: 1,
      title: "Request a site assessment",
      description: "Fill out the form below to get started"
    },
    {
      number: 2,
      title: "We assess the block",
      description: "We agree scope and schedule that works for you"
    },
    {
      number: 3,
      title: "Cleaning begins",
      description: "On a fixed, reliable rota — no chasing required"
    }
  ]
};

export const formData = {
  title: "Request a Free Site Assessment",
  reassurance: "We'll confirm a short site visit and provide a clear monthly quote — no obligation.",
  submitText: "Request Site Assessment",
  roleOptions: [
    { value: "estate_agent", label: "Estate Agent" },
    { value: "property_manager", label: "Property Manager" },
    { value: "block_manager", label: "Block Manager" },
    { value: "other", label: "Other" }
  ],
  blockCountOptions: [
    { value: "1", label: "1" },
    { value: "2-5", label: "2–5" },
    { value: "6+", label: "6+" }
  ],
  frequencyOptions: [
    { value: "weekly", label: "Weekly" },
    { value: "fortnightly", label: "Fortnightly" },
    { value: "not_sure", label: "Not sure" }
  ]
};

export const footerData = {
  companyName: "Just Cleaned",
  tagline: "Communal block cleaning",
  location: "Serving North & Greater London",
  insurance: "Fully insured (Public, Employer's & Professional Indemnity)"
};

export const thankYouData = {
  title: "Thank you — we've received your request.",
  message: "A member of our team will call you shortly to confirm details and arrange a short site assessment.",
  whatHappensNext: {
    title: "What happens next",
    body: "We'll give you a quick call to understand the block, confirm scope, and agree next steps. No sales pressure — just a short, professional call to get things moving."
  },
  secondaryReassurance: "If you miss our call, we'll follow up by email."
};
